export const dateTime = {
  formatUstTimeStamps(date) {
    if (!date) return "-";

    const d = new Date(date);

    const day = String(d.getUTCDate()).padStart(2, "0");
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const year = d.getUTCFullYear();

    const hours = d.getUTCHours();
    const minutes = String(d.getUTCMinutes()).padStart(2, "0");

    const formattedHours = hours % 12 || 12;
    const ampm = hours >= 12 ? "PM" : "AM";

    return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
  },

  formatDateTime(date) {
    if (!date) return "-";

    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    const hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");

    const formattedHours = hours % 12 || 12;
    const ampm = hours >= 12 ? "PM" : "AM";

    return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
  },

  formatTime(datetime) {
    if (!datetime) return "N/A";

    return new Date(datetime).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  },

  formatDate(datetime) {
    if (!datetime) return "N/A";
    return new Date(datetime).toDateString();
  },
};